import { IGetQuestions } from '@/contracts/modules/education/use-case/IGetQuestions'
import { IQuestionRecord } from '@/contracts/modules/education/entities/IQuestionRecord'
import { GetQuestionsRoute } from '@/modules/education/v1/api/v1/questions/GetQuestions/GetQuestionsRoute'
import { GetQuestionsParams } from '@/modules/education/v1/api/v1/questions/Dto/GetQuestionsParams'

export class GetQuestions implements IGetQuestions {
  async exec(node?: string): Promise<IQuestionRecord[]> {
    const response = await new GetQuestionsRoute().exec(new GetQuestionsParams({ node }))
    if (!response.isSuccess()) {
      throw new Error(response.getError())
    }
    return response.getData().questions
  }
}
